'use client';

import { useState } from 'react';
import { Copy, Check } from 'lucide-react';

interface CodeBlockProps {
  code: string;
  language?: string;
  title?: string;
}

export default function CodeBlock({ code, language, title }: CodeBlockProps) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    await navigator.clipboard.writeText(code);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="rounded-xl overflow-hidden bg-slate-950 text-slate-50 my-4">
      {title && (
        <div className="flex items-center justify-between px-4 py-2 border-b border-slate-800 bg-slate-900">
          <span className="text-xs font-medium text-slate-400">{title}</span>
          <button
            onClick={handleCopy}
            className="text-slate-400 hover:text-slate-200 transition-colors"
            aria-label="Copy code"
          >
            {copied ? <Check className="w-4 h-4" /> : <Copy className="w-4 h-4" />}
          </button>
        </div>
      )}
      <div className="relative">
        {!title && (
          <button
            onClick={handleCopy}
            className="absolute top-3 right-3 text-slate-400 hover:text-slate-200 transition-colors"
            aria-label="Copy code"
          >
            {copied ? <Check className="w-4 h-4" /> : <Copy className="w-4 h-4" />}
          </button>
        )}
        <pre className="overflow-x-auto p-4 text-sm leading-relaxed">
          <code className={language ? `language-${language}` : undefined}>
            {code}
          </code>
        </pre>
      </div>
    </div>
  );
}
